import { render, staticRenderFns } from "./ModalConfigCheckout.vue?vue&type=template&id=5fa4b29e&"
import script from "./ModalConfigCheckout.vue?vue&type=script&lang=js&"
export * from "./ModalConfigCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports